import React from 'react'
import MappingScreen from '../Components/MappingScreenComp/MappingScreen'

const MappingScreenView = () => {
  return (
    <div>
        <MappingScreen />
    </div>
  )
}

export default MappingScreenView